var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"radioGroup",staticClass:"form-input radio-group",class:{
    valid: !_vm.errorInternal,
    invalid: _vm.errorInternal,
  }},[_vm._t("label",[(_vm.label)?_c('h3',{staticClass:"label"},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")]):_vm._e()]),_c('RadioItems',_vm._b({on:{"input":_vm.onInput,"invalid":_vm.validate}},'RadioItems',_vm.$props,false)),(_vm.errorInternal)?_c('span',{staticClass:"message invalid"},[_vm._v(_vm._s(_vm.errorInternal))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }